import React from 'react';
import classnames from 'classnames';
import isMobile from 'ati-utils/isMobile';
import * as styles from './FilterIcon.scss';

const isMobileMode = isMobile();

const FilterIcon = (props) => {
  const {
    icon,
    iconSelected,
    text,
    pressed,
    handleClick,
  } = props;

  return (
    <button
      className={classnames(
        'glz-button',
        'glz-is-small',
        'glz-is-colorfull-icon',
        styles.filterButton,
        { 'glz-is-primary': pressed },
        { 'glz-has-no-hover': isMobileMode },
      )}
      onClick={() => handleClick(!pressed)}
    >
      <span className={classnames(
        { [styles.hidden]: !pressed },
        'glz-before-icon',
      )}
      >
        {iconSelected}
      </span>
      <span className={classnames(
        { [styles.hidden]: pressed },
        'glz-before-icon',
      )}
      >
        {icon}
      </span>
      <span>{text}</span>
    </button>
  );
};

export default FilterIcon;
